// *We consider key as common if it is used in more than one entity

export enum CommonKeys {
  Name = 'name',
  Owners = 'owners',
  Domains = 'domains',
  Description = 'description',
  DateCreated = 'dateCreated',
  DateReviewed = 'dateReviewed',
  ValidationStatus = 'validationStatus',
  QnousRef = 'qnous_ref',
  NistRef = 'nist',
  IsoRef = 'iso',
  IsmRef = 'ism',
  CisRef = 'cis',
  OperationalStatus = 'operational_status',
  TimelineStartDate = 'timelineStartDate',
  TimelineEndDate = 'timelineEndDate',
  Metrics = 'metrics',
  CurrentMaturity = 'current_maturity',
  TargetMaturity = 'target_maturity',
  OperationalModel = 'operational_model',
  OperationalEffectiveness = 'operational_effectiveness',
  DesignEffectiveness = 'design_effectiveness',
  Assurance = 'assurance_level',
  Coverage = 'coverage',
  Applicability = 'applicability',
  Partners = 'partners',
  IsReported = 'is_reported',
}

export type CoreFormKeysType = typeof CoreFormKeys;
export const CoreFormKeys = [
  CommonKeys.Name,
  CommonKeys.Owners,
  CommonKeys.Domains,
  CommonKeys.ValidationStatus,
  CommonKeys.DateCreated,
  CommonKeys.DateReviewed,
] as const;

export const CoreRequiredKeys = [
  CommonKeys.Name,
  CommonKeys.Domains,
  CommonKeys.Owners,
] as const;

export type LogicPhysicalFormKeysType = typeof LogicPhysicalKeys;
export const LogicPhysicalKeys = [
  ...CoreFormKeys,
  CommonKeys.QnousRef,
  CommonKeys.NistRef,
  CommonKeys.IsoRef,
  CommonKeys.IsmRef,
  CommonKeys.CisRef,
  CommonKeys.Description,
  CommonKeys.OperationalStatus,
  CommonKeys.TimelineStartDate,
  CommonKeys.TimelineEndDate,
  CommonKeys.Metrics,
  CommonKeys.CurrentMaturity,
  CommonKeys.TargetMaturity,
  CommonKeys.OperationalModel,
  CommonKeys.Partners,
  CommonKeys.OperationalEffectiveness,
  CommonKeys.DesignEffectiveness,
  CommonKeys.Assurance,
  CommonKeys.Coverage,
  CommonKeys.Applicability,
  CommonKeys.IsReported,
] as const;
